import { render, staticRenderFns } from "./AddTemplateMessage.vue?vue&type=template&id=61c1cf4e&scoped=true&"
import script from "./AddTemplateMessage.vue?vue&type=script&lang=js&"
export * from "./AddTemplateMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateMessage.vue?vue&type=style&index=0&id=61c1cf4e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1cf4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
